<i18n lang='yml' src='../i18n/RoleNameAndNalbs.yml'></i18n>

<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else>
    <div class='form-group row'>
      <div class='col-sm-12 col-md-6'>
        <label :for="'name_en-role' + roleIndex">
          {{ $t('name_en') }}
          <span class='red'>*</span>
        </label>
        <input :id="'name_en-role' + roleIndex" class='form-control' v-model='role.nameEN' :name='fieldName + "[name_en]"'>
      </div>
      <div class='col-sm-12 col-md-6'>
        <label :for="'name_fr-role' + roleIndex">{{ $t('name_fr') }}</label>
        <input :id="'name_fr-role' + roleIndex" class='form-control' v-model='role.nameFR' :name='fieldName + "[name_fr]"'>
      </div>
    </div>

    <div class='form-group row'>
      <div class='col-sm-3'>
        <input type='hidden' :name='fieldName + "[default_role]"' value='false' v-if="!role.defaultRole">
        <label>
          <input v-on:change="enforceDefaultValidity('default')" :id="'default_role-role' + roleIndex" type='checkbox' :name='fieldName + "[default_role]"' :value='role.defaultRole' v-model='role.defaultRole' v-on:click='updateDefaultRole'>
          {{ $t('default_role') }}
        </label>
      </div>
      <div class='col-sm-3'>
        <label>
          <input type='hidden' :name='fieldName + "[requestable_role]"' value='false' v-if="!role.requestableRole">
          <input v-on:change="enforceDefaultValidity('requestable')" :id="'requestable_role-role' + roleIndex" type='checkbox' :name='fieldName + "[requestable_role]"' :value='role.requestableRole' v-model='role.requestableRole'>
          {{ $t('requestable_role') }}
        </label>
      </div>
    </div>

    <fieldset>
      <legend>{{ $t('nalbs') }}</legend>
      <div class='form-group row'>
        <div class='col-sm-12 col-md-6 col-lg-4' v-for='(nalb, index) in availableNalbs' v-bind:key="index">
          <label>
            <input type='checkbox' :value='nalb.id' :name='fieldName + "[enabled_nalbs][]"' v-model='nalb.selected'>
            {{ nalb.name }}
          </label>
        </div>
        <input type='hidden' :name='fieldName + "[enabled_nalbs][]"' value=''>
      </div>

      <div class='form-group row'>
        <div class='col-sm-12'>
          <label :for="'default_nalb-role' + roleIndex">{{ $t('default_nalb') }}</label>
          <select :id="'default_nalb-role' + roleIndex" class='form-control' :name='fieldName + "[default_nalb]"'>
            <option v-for='(nalb, index) in enabledNalbs' :value='nalb.id' :selected='nalb.default' v-bind:key="index">{{ nalb.name }}</option>
          </select>
        </div>
      </div>
    </fieldset>
    <div class='form-group row'>
      <role-abilities :role='role' :nalb='role' :permissions='permissions'
                      :fieldName='`${fieldName}[abilities][0]`'></role-abilities>
    </div>
    <div class='form-group row' v-for='(nalb, index) in enabledNalbs' v-bind:key="index">
      <role-abilities :locale='locale' :role='getAssociatedRole(nalb.name)' :nalb='nalb' :permissions='permissions'
                      :fieldName='`${fieldName}[abilities][${index+1}]`'></role-abilities>
    </div>
  </div>
</template>

<script>
    import roleAbilities from './RoleAbilities.vue';
    export default {
        components: {
            'role-abilities': roleAbilities
        },
        name: 'role-name-and-nalbs',
        props: ['locale', 'role', 'nalbs', 'fieldName', 'permissions', 'roleIndex'],
        data () {
            return { nalbData: JSON.parse(JSON.stringify(this.nalbs)), loading: true };
        },
        mounted () {
            this.$i18n.locale = this.locale;
            this.loading = false;
        },
        computed: {
            availableNalbs: function () {
                return this.nalbData.map((nalb) => {
                    let obj = nalb;
                    obj.selected = false;
                    obj.default = false;

                    const selected = this.role.enabledNalbs.find((role) => role[0] === nalb.id);
                    if (selected) {
                        obj.selected = true;
                        if (selected[1]) {
                          obj.default = true;
                        }
                    }
                    return obj;
                });
            },
            enabledNalbs: function () {
                return this.availableNalbs.filter((nalb) => nalb.selected);
            }
        },
        methods: {
            updateDefaultRole: function () {
                if (!this.role.defaultRole) {
                    this.$emit('selectDefaultRole', this.roleIndex);
                }
            },
            enforceDefaultValidity(clicked) {
                if (clicked === 'requestable' && !this.role.requestableRole) {
                    this.role.defaultRole = false;
                } else if (clicked === 'default' && this.role.defaultRole) {
                    this.role.requestableRole = true;
                }

            },
            getAssociatedRole(nalbName) {
                return this.role.children.find((el) => {
                    //Have to do this since the nalb names do not precisely match up with role names
                    return el.abilitable === nalbName;
                });
            },
        }
    }
</script>
